import { useSelector } from 'react-redux';

import {
    platform,
    PowerFunnelEvents,
    PowerFunnelSurfaces,
    SubscriptionTypes,
} from '../Analytics/constants';
import { trackEvent } from '../Analytics/TrackedClick';

export const usePowerFunnelTracking = ({
    referringSurface,
    gatedFeature = null,
    prismicTitle,
    sourceEventId,
} = {}) => {
    const user = useSelector(({ auth }) => auth?.user);
    const userSubscriptionStatus = user?.isPowered ? SubscriptionTypes.POWER : SubscriptionTypes.FREE;
    const resolvedReferringSurface = referringSurface || PowerFunnelSurfaces.UNKNOWN;

    if (process.env.NODE_ENV !== 'production' && resolvedReferringSurface === PowerFunnelSurfaces.UNKNOWN) {
        // eslint-disable-next-line no-console
        console.error('usePowerFunnelTracking: referringSurface missing — emitting web_unknown');
    }

    const fire = (eventName, extraProps = {}) => {
        trackEvent(eventName, {
            platform,
            userSubscriptionStatus,
            referringSurface: resolvedReferringSurface,
            gatedFeature,
            ...(prismicTitle && { prismicTitle }),
            ...(sourceEventId && { sourceEventId }),
            ...extraProps,
        });
    };

    const trackPowerPaywallViewed = () => fire(PowerFunnelEvents.POWER_PAYWALL_VIEWED);

    const trackPowerCheckoutStarted = ({
        billingCycle,
        priceLocal,
        currency,
    } = {}) => fire(PowerFunnelEvents.POWER_CHECKOUT_STARTED, {
        planSelected: SubscriptionTypes.POWER,
        billingCycle,
        priceLocal,
        currency,
    });

    const trackPowerPurchaseSucceeded = ({
        billingCycle,
        priceLocal,
        currency,
    } = {}) => fire(PowerFunnelEvents.POWER_PURCHASE_SUCCEEDED, {
        billingCycle,
        priceLocal,
        currency,
    });

    return {
        trackPowerPaywallViewed,
        trackPowerCheckoutStarted,
        trackPowerPurchaseSucceeded,
    };
};
